import { useEffect, useState } from 'react';
import { FullWidthContainer, MaxWidthContainer, DownArrow } from '@/components';
import Image from 'next/image';

const GoogleReviews = () => {
    const [isIframeOpen, setIsIframeOpen] = useState(false);
    const [keyNumber, setKeyNumber] = useState(Math.random());

    useEffect(() => {
        setKeyNumber(Math.random());
    }, [isIframeOpen]);

    return (
        <div className="p-4">
            <button
                onClick={() => setIsIframeOpen(!isIframeOpen)}
                className="text-bold text-3xl py-4 mx-auto mb-4 flex border-2 rounded-lg border-[#A3C159]"
            >
                <div className="flex flex-wrap justify-center">
                    <Image
                        unoptimized={true}
                        src="/images/google/google-reviews-logo.png"
                        alt="Google reviews"
                        width={240}
                        height={150}
                        style={{ width: 'auto' }}
                        className="max-w-[256px]"
                    />
                    <span className="text-sm w-full text-gray-500">
                        Click to see our reviews!
                    </span>
                </div>
            </button>
            <div className={isIframeOpen ? '' : 'hidden'}>
                <FullWidthContainer dark>
                    <MaxWidthContainer>
                        <iframe
                            // Added a key so each time this is opened it refreshes itself
                            key={keyNumber}
                            src="https://widgets.sociablekit.com/google-reviews/iframe/25401427"
                            width="100%"
                            height="600"
                            style={{ border: 0 }}
                            allowFullScreen={true}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="pt-2 pb-4 min-h-96"
                        ></iframe>
                    </MaxWidthContainer>
                </FullWidthContainer>
                <DownArrow dark />
            </div>
        </div>
    );
};

export default GoogleReviews;
